<template>
  <div class="mt-4">
    <filter-bar @dailyReport="handleReport"></filter-bar>
    <div class="md-layout">
      <div class="md-layout-item content">
        <report-empty-state
          v-if="hasNoReportView"
          :title="$t('daily_attendance.data_empty_title')"
          :desc="$t('daily_attendance.data_empty_des')"
        ></report-empty-state>
        <template v-else>
          <Detail
            ref="detail"
            :percentStudent="percentStudent"
            :detail="detail"
          ></Detail>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import FilterBar from "./FilterBar.vue";
import Detail from "./Detail.vue";
import ReportEmptyState from "@/pages/Report/Components/EmptyState.vue";
import { service_paths } from "@/constants/Services";
import moment from "moment";
import { convertTimeByTimezone } from "@/helpers/datetime-helper";
import { mapGetters } from "vuex";
import { getId } from "../../../../helpers/utils";
import { ISIS_FORMAT } from "@/helpers/datetime-helper";
const clientLocale = localStorage.getItem("language");
const formatDateClient =
  clientLocale === "en" ? "MM-DD-YYYY hh:mm a" : "DD-MM-YYYY hh:mm a";

export default {
  components: {
    FilterBar,
    Detail,
    ReportEmptyState
  },
  data() {
    return {
      hasNoReportView: true,
      percentStudent: [],
      detail: {},
      queryParams: {}
    };
  },
  computed: {
    ...mapGetters("user", {
      userTz: "timezone"
    })
  },
  methods: {
    formatDateTime(date, userTimeZone) {
      return convertTimeByTimezone(
        date,
        "Etc/UTC",
        userTimeZone ?? moment.tz.guess(),
        formatDateClient
      );
    },
    convertDate(item) {
      let date = new Date();
      const currentDate = moment(date).format(ISIS_FORMAT.date);
      item.date = this.formatDateTime(item.date, this.userTz);
      const attendanceDate = moment(item.date).format(ISIS_FORMAT.date);
      if (attendanceDate !== currentDate && !item.status) {
        item.status = "unchecked";
      }
    },
    async handleReport(queryParams) {
      let percentStudent = await this.$axios
        .get(
          `${service_paths.attendances}/percent-student`,
          queryParams,
          undefined,
          undefined,
          undefined,
          undefined,
          false
        )
        .then(response => response.data);
      let arrayPercentStudent = [];
      for (let key in percentStudent) {
        if (key !== "sum_number_student") {
          arrayPercentStudent.push({
            ...percentStudent[key],
            name: key,
            isPercent: true
          });
        }
      }
      this.percentStudent = arrayPercentStudent;
      let detail = await this.$axios
        .get(`${service_paths.reports}/attendance/daily-attendance`, {
          ...queryParams,
          class_status: "On-going"
        })
        .then(response => response.data);
      Object.values(detail.attendance).forEach(attendance => {
        attendance.forEach(item => {
          this.convertDate(item);
        });
      });
      let dataMerge = {};
      for (let item in detail.attendance) {
        dataMerge[item] = {
          attendance: detail.attendance[item]
        };
      }
      Object.entries(detail.meta_data).map(meta => {
        dataMerge[meta[0]].date = meta[0];
        dataMerge[meta[0]] = Object.assign(dataMerge[meta[0]], meta[1]);
      });
      this.detail = dataMerge;
      this.queryParams = { ...queryParams };
      this.hasNoReportView = false;
    }
  }
};
</script>
<style lang="scss" scoped></style>
